<template>
  <div class="language-setting page">
    <van-nav-bar :title="$t('语言')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back" />
      </template>
    </van-nav-bar>

    <div class="language-intro">
      <div class="intro-title">{{ $t('语言切换') }}</div>
      <div class="intro-text">{{ $t('选择后将立即切换系统语言显示。') }}</div>
    </div>

    <button class="language-option" type="button" @click="setLocale('zh-CN')">
      <span class="flag flag-cn" aria-hidden="true"></span>
      <span class="label">{{ $t('简体中文') }}</span>
      <van-icon v-if="currentLocale === 'zh-CN'" class="selected" name="success" />
    </button>

    <button class="language-option" type="button" @click="setLocale('ja-JP')">
      <span class="flag flag-jp" aria-hidden="true"></span>
      <span class="label">{{ $t('日本語') }}</span>
      <van-icon v-if="currentLocale === 'ja-JP'" class="selected" name="success" />
    </button>

    <button class="language-option" type="button" @click="setLocale('en-US')">
      <span class="flag flag-us" aria-hidden="true"></span>
      <span class="label">English</span>
      <van-icon v-if="currentLocale === 'en-US'" class="selected" name="success" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'LanguageSetting',
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    setLocale(locale) {
      if (!['zh-CN', 'ja-JP', 'en-US'].includes(locale)) return;
      localStorage.setItem('site-locale', locale);
      this.$i18n.locale = locale;
      document.documentElement.lang = locale === 'ja-JP' ? 'ja' : (locale === 'en-US' ? 'en' : 'zh-CN');
      window.location.reload();
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.replace({ path: '/Login' });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
@accent: #be9f80;

.language-setting {
  min-height: 100vh;
  padding: 0 20px 40px;
  color: #fff;
}

.language-setting .nav-bar {
  margin: 0 -20px 20px;
}

.language-intro,
.language-option {
  width: 100%;
  margin-bottom: 18px;
  padding: 26px 24px;
  color: #fff;
  text-align: left;
  background: linear-gradient(120deg, #212121, #313131);
  border: 2px solid rgba(190, 159, 128, .7);
  border-radius: 16px;
}

.intro-title {
  margin-bottom: 12px;
  font-size: 34px;
  font-weight: 700;
}

.intro-text {
  color: #bbb;
  font-size: 26px;
}

.language-option {
  display: flex;
  align-items: center;
  min-height: 100px;
  font-size: 32px;
  outline: none;
}

.flag {
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  margin-right: 14px;
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border: 1px solid rgba(255, 255, 255, .35);
  border-radius: 50%;
}

.flag-cn {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' fill='%23de2910'/%3E%3Cpath d='M16 10l2.7 8.3h8.7l-7 5.1 2.7 8.3-7.1-5.1-7.1 5.1 2.7-8.3-7-5.1h8.7z' fill='%23ffde00'/%3E%3C/svg%3E");
}

.flag-jp {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' fill='white'/%3E%3Ccircle cx='32' cy='32' r='18' fill='%23bc002d'/%3E%3C/svg%3E");
}

.flag-us {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' fill='white'/%3E%3Cg fill='%23b22234'%3E%3Crect y='0' width='64' height='5'/%3E%3Crect y='10' width='64' height='5'/%3E%3Crect y='20' width='64' height='5'/%3E%3Crect y='30' width='64' height='5'/%3E%3Crect y='40' width='64' height='5'/%3E%3Crect y='50' width='64' height='5'/%3E%3Crect y='60' width='64' height='4'/%3E%3C/g%3E%3Crect width='30' height='35' fill='%233c3b6e'/%3E%3Cg fill='white'%3E%3Ccircle cx='6' cy='7' r='2'/%3E%3Ccircle cx='15' cy='7' r='2'/%3E%3Ccircle cx='24' cy='7' r='2'/%3E%3Ccircle cx='6' cy='17' r='2'/%3E%3Ccircle cx='15' cy='17' r='2'/%3E%3Ccircle cx='24' cy='17' r='2'/%3E%3Ccircle cx='6' cy='27' r='2'/%3E%3Ccircle cx='15' cy='27' r='2'/%3E%3Ccircle cx='24' cy='27' r='2'/%3E%3C/g%3E%3C/svg%3E");
}

.label {
  flex: 1;
  font-weight: 600;
}

.selected {
  color: @accent;
  font-size: 38px;
}
</style>
